import * as yup from 'yup';

export const newKitSchema = yup.object().shape({
  kit_name: yup.string().required('É necessário um nome'),
  kit_cost: yup.string().required('É necessário informar um custo de kit'),
});
